import templateUrl from 'emun.customer/customer-categories-purchased.htm'
import controller from 'emun.customer/customer-categories-purchased.controller'

export default {
    bindings: {
        customer: '<'
    },
    controller,
    templateUrl($element, $attrs) {
        return $attrs.templateUrl || templateUrl
    }
};